
import { mdlBaseRequest } from "../models/service-models/common/BaseRequest";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlRegionListReponse } from "../models/service-models/region/RegionListReponse";
import { mdlRegionListRequest } from "../models/service-models/region/RegionListRequest";
import { mdlRegionSubListRequest } from "../models/service-models/region/RegionSubListRequest";
import { GetResponse } from "../utils/ApiClient";

module RegionService {
    export async function List(
        pRequest: mdlRegionListRequest
    ): Promise<mdlServiceResponse<mdlRegionListReponse>> {
        return await GetResponse<mdlServiceResponse<mdlRegionListReponse>>(
            "region/list",
            pRequest
        );
    }
    export async function SubList(
        pRequest: mdlRegionSubListRequest
    ): Promise<mdlServiceResponse<mdlRegionListReponse>> {
        return await GetResponse<mdlServiceResponse<mdlRegionListReponse>>(
            "region/sub-region-list",
            pRequest
        );
    }
}
export { RegionService };
